import apiService from '../services/APIService';
import Response from '../modules/classes/Response';
import {defaultUserController} from './UserController';

const OTP_TYPES = {
  SIGNUP: "signup",
  RESET_PASSWORD: "reset_password",
  TWO_STEP_VERIFICATION: "two_factor",
}

const PROVIDERS = {
  GOOGLE: "google",
  FACEBOOK: "facebook",
  APPLE: "apple",
}

class AuthController {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async generateToken(email) {
    let token = '';
    while (token.length < 64) {
      token += Math.random().toString(36).substring(2); // base36 characters
    }
    token = token.substring(0, 64); // Trim to exactly 64 characters
  
    try {
      localStorage.setItem('auth_credentials', JSON.stringify({ email, token }));
    } catch (error) {
      console.error('Error storing token:', error);
    }
  
    return token;
  }

  async getToken(email) {
    try {
      const credentialsJson = localStorage.getItem('auth_credentials');
      if (credentialsJson) {
        const data = JSON.parse(credentialsJson);
        if (data && data.email === email) {
          return data.token;
        }
      }
      return null;
    } catch (error) {
      console.error('Error retrieving token:', error);
      return null;
    }
  }
  async generateEmailOTP(email) {
    // Generate a 6-digit numeric OTP
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    await this.storeEmailOTP(email, otp);
    return otp;
  }

  async storeEmailOTP(email, otp) {
    try {
      localStorage.setItem('auth_email_otp', JSON.stringify({email, otp}));
    } catch (error) {
      console.error('Error storing email OTP:', error);
    }
  }

  async getEmailOTP(email) {
    try {
      const otpJson = localStorage.getItem('auth_email_otp');
      if (otpJson) {
        const data = JSON.parse(otpJson);
        if (data && data.email === email) {
          return data.otp;
        }
      }
      return null;
    } catch (error) {
      console.error('Error retrieving email OTP:', error);
      return null;
    }
  }

  async loginAdmin(email, password) {
    return this.login(email, password, 'admin');
  }

  async login(email, password, role = 'user') {
    return new Promise((resolve, reject) => {
      this.apiService.requestWithRawJson('/auth/login', 'POST', { identifier: email, password, role })
        .then((res) => {
          const response = Response.parse(res);
          console.log("login", response);

          if (response.statusCode === 201) {
            if (response.data.requires2FA) {
              resolve(response);
            } else {
              // Store the token in localStorage for the interceptor to use
              localStorage.setItem('@auth_token', response.data.accessToken);

              defaultUserController
                .getProfile()
                .then((userResponse) => {
                  const user = userResponse?.data;
                  if (user) {
                    localStorage.setItem('@user_data', JSON.stringify(user));
                  }
                })
                .catch((err) => {
                  console.error('Error fetching user profile:', err);
                });

              resolve(response);
            }
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          console.error('Login error:', err);
          reject(err);
        });
    });
  }

  verify2FA(tempToken, otp) {
    return new Promise((resolve, reject) => {
      this.apiService.requestWithRawJson('/auth/verify-2fa-login','POST', { tempToken, otp }).then((res) => {
        const response = Response.parse(res);
        resolve(response);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  register(userData) {
    return this.apiService.post('/auth/register', userData);
  }

  logout() {
    return this.apiService.post('/auth/logout');
  }

  isEmailValid(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    return emailRegex.test(email);
  }

  async isUserExists(identifier) {
    return new Promise((resolve, reject) => {
      this.apiService.requestWithParams('/auth/username-exists', 'GET', { identifier }).then((res) => {
        resolve(true)
      }).catch((err) => {
        // User doesn't exist (409) or other error
        resolve(false);
      });
    });
  }

  async sendOTP(email, type) {
    return new Promise( async (resolve, reject) => {

      const token = await this.generateToken(email);

      console.log("Send OTP data", { email, token, type });
      this.apiService.requestWithRawJson('/auth/verify-email', 'POST', { email, token, type }).then((res) => {
        console.log("res", res);
        resolve(Response.parse(res));
      }).catch((err) => {
        console.log("err", err);
        reject(err);
      });

      // const exists = await this.isUserExists(email);

      // this.isUserExists(email).then(async () => {
      //   if (type === OTP_TYPES.SIGNUP) {
      //       reject(new Error('Email already exists'));
      //   }
      // }).catch((err) => {
      //   if (type !== OTP_TYPES.SIGNUP) {
      //       reject(new Error('Email does not exist'));
      //   } 
      // }).finally(async () => {
      //   const token = await this.generateToken(email);
      //   apiService.requestWithRawJson('/auth/verify-email', 'POST', { email, token, type }).then((res) => {
      //     console.log("res", res);
      //     resolve(Response.parse(res));
      //   }).catch((err) => {
      //     console.log("err", err);
      //     reject(err);
      //   });
      // });
    });
  }

  // Sign Up
  async signUp(userData, step = 1) {
    let token = null;

    switch (step) {
      case 1:
        return new Promise((resolve, reject) => {
          this.isUserExists(userData.username).then((res) => {
            reject(res);
          }).catch((err) => {
            resolve(err);
          });
        });
      case 2:
        return new Promise((resolve, reject) => {
          this.isUserExists(userData.email).then(() => {
            reject(false);
          }).catch((err) => {
            console.log(err)
              this.sendOTP(userData.email, OTP_TYPES.SIGNUP).then((res) => {
                console.log("res", res);
                resolve(res);
              }).catch((err) => {
                console.log("err", err);
                reject('Can\'t send OTP');
              });
          });
        });

      case 3:
        return this.verifyOTP(userData.email, userData.otp, OTP_TYPES.SIGNUP);
      case 4:
        return this.finalSignUp(userData); 
      default:
        throw new Error('Invalid step');
    }
  }

  async finalSignUp(userData, avatarFile = null) {
    // Create FormData and append all fields
    const formData = new FormData();
  
    // Append each field from userData to formData
    Object.keys(userData).forEach(key => {
      // Skip file objects as they need special handling
      if (userData[key] instanceof File) {
        formData.append(key, userData[key]);
      } else if (typeof userData[key] === 'object' && userData[key] !== null) {
        // Stringify objects
        formData.append(key, JSON.stringify(userData[key]));
      } else {
        // Handle primitive values
        formData.append(key, userData[key]);
      }
    });

    // Add avatar file if provided
    if (avatarFile) {
      formData.append('avatar', avatarFile);
    }

    console.log('Sending form data:', Object.fromEntries(formData)); // For debugging

    return new Promise((resolve, reject) => {
      this.apiService.requestWithFormData('/auth/signup', 'POST', formData)
        .then((res) => {
          resolve(Response.parse(res));
        })
        .catch((err) => {
          console.error('Signup error:', err);
          reject(Response.error(err.message || 'An error occurred during signup'));
        });
    });
  }

  async forgotPassword(email) {
    return new Promise((resolve, reject) => {
      this.sendOTP(email, OTP_TYPES.RESET_PASSWORD).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async verifyForgotPassword(email, otpValue) {
    return this.verifyOTP(email, otpValue, OTP_TYPES.RESET_PASSWORD);
  }

  async verifyOTP(email, otpValue, type) {
    return new Promise(async (resolve, reject) => {
      const token = await this.getToken(email);

      if (!token) {
        reject(new Error('Token not found'));
      }

      this.apiService.requestWithRawJson('/auth/confirm-email', 'POST', { otp: otpValue, token, type }).then((res) => {
          resolve(Response.parse(res));
        }).catch((err) => {

          console.log("err", err);

          reject(err);
        });
    });
  }

  async resetPassword(email, password) {
    const token = await this.getToken(email);

    return this.apiService.requestWithRawJson('/auth/change-password', 'PATCH', { token, email, newPassword: password });
  }

  async resendOtp(email) {
    return this.sendOTP(email, OTP_TYPES.SIGNUP);
  }

  signInWithGoogle(idToken, web = false ) {
    return this.apiService.requestWithRawJson('/auth/social-login', 'POST', { idToken, provider: PROVIDERS.GOOGLE, web });
  }

  signInWithFacebook(idToken, web = false) {
    return this.apiService.requestWithRawJson('/auth/social-login', 'POST', { idToken, provider: PROVIDERS.FACEBOOK, web });
  }

  signInWithApple(idToken, web = false) {
    return this.apiService.requestWithRawJson('/auth/social-login', 'POST', { idToken, provider: PROVIDERS.APPLE, web });
  }

  firstTimeLogin(email, password) {
    return this.login(email, password);
  }

  toggleTwoStepVerification(email) {
    return this.sendOTP(email, OTP_TYPES.TWO_STEP_VERIFICATION);
  }

  async confirmTwoStepVerification(email, otpValue, enabled) {

    console.log("confirm data: ", {
      otp: otpValue,
      type: OTP_TYPES.TWO_STEP_VERIFICATION,
      enable: enabled,
      token: await this.getToken(email)
    })
    
    return this.apiService.requestWithRawJson('/auth/confirm-2fa', 'POST', {
      otp: otpValue,
      type: OTP_TYPES.TWO_STEP_VERIFICATION,
      enable: enabled,
      token: await this.getToken(email)
    });
  }

  healthCheck() {
    return this.apiService.get('/health');
  }
}

export {OTP_TYPES, PROVIDERS}

export default AuthController;
